import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-707a2c57"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "svg-map-wrap",
  id: "map-container",
  ref: "container"
}
const _hoisted_2 = {
  id: "counties",
  transform: "translate(0 .10698)",
  style: {"fill":"lightgrey","stroke-width":".17829","stroke":"#fff"}
}
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id", "d"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  id: "separator",
  class: "separator"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "separatorAK,HI",
    d: "m275.15 525.53v63.053l41.271 37.326m-315.26-178.34h197.18l76.81 77.957h98.592l60.76 61.907v38.472",
    style: {"fill":"none","stroke-width":"2.3177","stroke":"#a9a9a9"}
  })
], -1))
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-wrap mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_list_item = _resolveComponent("list-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", {
        width: "989.98",
        height: "627.07",
        viewbox: "0 0 989.98 627.07",
        style: _normalizeStyle({ 'transform': `scale(${_ctx.scale})` })
      }, [
        _createElementVNode("g", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countiesConfig, ({ state, counties }) => {
            return (_openBlock(), _createElementBlock("g", {
              id: state,
              key: state,
              class: "state"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(counties, ({ path, name, id }) => {
                return (_openBlock(), _createElementBlock("path", {
                  key: id,
                  id: `c${id}`,
                  d: path,
                  style: {"stroke":"#000"},
                  class: _normalizeClass({
              'is-active': _ctx.footprints.includes(id),
            })
                }, [
                  _createElementVNode("title", null, _toDisplayString(name), 1)
                ], 10, _hoisted_4))
              }), 128))
            ], 8, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("g", {
          id: "Borders",
          innerHTML: _ctx.countiesBorder.join()
        }, null, 8, _hoisted_5),
        _hoisted_6
      ], 4))
    ], 512),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "text-sm border text-dark rounded-md cursor-pointer px-4 py-2.5 hover:border-gray-900",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isVisible = true))
          }, " Show counties list "))
        : _createCommentVNode("", true),
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footprints, (item, index) => {
              return (_openBlock(), _createBlock(_component_list_item, { key: index }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.typeNamesMap[item] || item), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "text-sm border text-dark rounded-md cursor-pointer px-4 py-2.5 hover:border-gray-900",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isVisible = false))
          }, " Hide counties list "))
        : _createCommentVNode("", true)
    ])
  ], 64))
}